export const payoutMethods = [
    'ach_bank_transfer',
    'sepa_bank_transfer',
    'gbp_bank_transfer',
    'gbp_open_banking_payment',
    'credit_debit_card',
    'paypal',
    'venmo',
    'moonpay_balance',
    'cash_app',
];
export function isWithdrawalMethod(value) {
    return value === 'manual_withdraw' || payoutMethods.some((method) => method === value);
}
export const withdrawalArtwork = {
    ach_bank_transfer: 'ach',
    sepa_bank_transfer: 'sepa',
    gbp_bank_transfer: 'uk',
    gbp_open_banking_payment: 'uk-open',
    credit_debit_card: 'card',
    paypal: 'paypal',
    venmo: 'venmo',
    moonpay_balance: 'moonpay',
    cash_app: 'cash-app',
    manual_withdraw: 'manual-withdraw',
};
